import { render, staticRenderFns } from "./need-password.vue?vue&type=template&id=a8bdb9c6&scoped=true&"
import script from "./need-password.vue?vue&type=script&lang=js&"
export * from "./need-password.vue?vue&type=script&lang=js&"
import style0 from "./need-password.vue?vue&type=style&index=0&id=a8bdb9c6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8bdb9c6",
  null
  
)

export default component.exports